import React from 'react';
import styled from 'styled-components';
import { theme } from '../styles/theme'; // Import the theme

const FormWrapper = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: ${theme.spacing.md}; // Use theme spacing
  background: ${theme.colors.background};
  width: 40vw; // Set width to 50vw
  max-width: 70rem;
  max-height: 50svh; // Set height to 50svh
`;

const TextColumn = styled.div`
  flex: 1;
  padding: ${theme.spacing.lg}; // Improved spacing
  max-width: 50%;

  h2 {
    margin-bottom: ${theme.spacing.md}; // Space below the heading
  }

  p {
    margin-bottom: ${theme.spacing.lg}; // Space between paragraphs
    line-height: ${theme.typography.lineHeights.body}; // Use theme line height
}
  .disclaimer {
    font-size: ${theme.typography.sizes.caption}; // Smaller font size for disclaimer
    color: ${theme.colors.textLight}; // Lighter color for disclaimer
    margin-top: ${theme.spacing.sm}; // Space above the disclaimer
  }
`;

const FormColumn = styled.div`
  flex: 1;
  max-width: 50%;
  
  .ck-fm {
    width: 90%;
    margin: auto;
    padding: ${theme.spacing.lg}; // Use theme spacing
    border-radius: ${theme.radii.card}; // Use theme radius
    background: linear-gradient(45deg, ${theme.colors.text}, ${theme.colors.text}); // Use theme colors
  }

  .ck-fm input,
  .ck-fm button {
    width: 100%;
    padding: ${theme.spacing.md}; // Use theme spacing
    border: 0;
    border-radius: inherit;
    box-shadow: ${theme.shadows.sm}; // Use theme shadow
  }

  .ck-fm input {
    display: block;
    height: 3rem;
    margin: 0 0 ${theme.spacing.sm}; // Use theme spacing
    margin-bottom: 1.5rem; // Add this line for additional spacing
  }

  .ck-fm button {
    background: ${theme.colors.brand};
    color: ${theme.colors.text};
    font-weight: bold;
    transition: transform 0.3s cubic-bezier(0.5, 0, 0.5, 1), opacity 0.2s linear;
    cursor: pointer;
  }

  .ck-fm button:hover {
    transform: scale(1.02);
    background: ${theme.colors.hover};
  }
`;

const ConvertkitFormComponent = () => {
  const FORM_ID = '2a3e7f89b1'; // Your form ID from the embed code

  return (
    <FormWrapper>
      <TextColumn>
        <h2>Join the waitlist</h2>
        <p>Waitlisters will get an exclusive discount on our lifetime deal.</p>
        <p>And our lifetime deal is already preeetty tasty!</p>
        <p className="disclaimer">
          Remember, like email vampires we can't come into your inbox unless you invite us in. And if you want us to leave, you can. Unsubscribe at any time and we'll vanish.
        </p>
      </TextColumn>
      <FormColumn>
        <form className="ck-fm" action={`https://app.convertkit.com/forms/${FORM_ID}/subscriptions`} method="post">
          <input type="text" name="fields[first_name]" placeholder="First Name" required />
          <input type="email" name="email_address" placeholder="Email Address" required />
          <button type="submit">Give me the good stuff!</button>
        </form>
      </FormColumn>
    </FormWrapper>
  );
};

export default ConvertkitFormComponent; 